import { InfoSheet } from '@/shared/components/ui/InfoSheet'
import { ScoringRulesContent } from './ScoringRulesContent'

type ScoringRulesSheetProps = {
  onClose: () => void
}

export function ScoringRulesSheet({ onClose }: ScoringRulesSheetProps) {
  return (
    <InfoSheet title="Como os pontos são calculados" onClose={onClose}>
      <ScoringRulesContent />
    </InfoSheet>
  )
}
